import { Box, ColorOptions, email, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { OTPValidationSchema, passwordValidationSchema } from '../../utils'
import { staticStrings } from '../../utils/constants'
import { ResendComponent } from './ResendComponent'

const textinputStyle = {
  type: 'body12',
  borderColor: 'ITEM_SEPARATOR' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 30,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: 'BLACK_21',
  labelFontSize: 12,
  fontSize: 12,
  paddingHorizontal: 16,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  onFocusBorderWidth: 1,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 16,
}

const ChangeEmailRightComp = ({ onPress, text }) => {
  return (
    <Box onPress={onPress}>
      <Text fontSize={12} color={'PRIMARY'} fontFamily="jiotype-medium">
        {text}
      </Text>
    </Box>
  )
}

// The shared Form intercepts Tab on a field and tries to focus the next form input itself. On the login form
// the next input can be hidden (OTP before it is sent), so Tab was swallowed and focus got stuck on the username.
// Giving the field its own key handler lets the browser move focus normally: username -> password / OTP ->
// show-password / resend -> Login / Send OTP button -> "Login using ..." link.
const allowBrowserTab = () => {}

export const loginFormData = (
  onHandleKeyPress: any,
  otpSent: boolean,
  setOtpSent,
  callGenerateOtpApi,
  generateOtpstate,
): any => [
  {
    formItems: [
      {
        fieldName: 'enterLoginCredentials',
        ComponentName: Text,
        title: staticStrings.login,
        type: 'h3',
        textAlign: 'center',
        color: 'BLACK_21',
        fontFamily: 'jiotype-medium',
        fontSize: 24,
      },
      {
        fieldName: 'userName',
        ComponentName: TextInputNew,
        // maxLength: 10,
        validationSchema: email,
        placeholder: staticStrings.userName,
        rightComponent: otpSent ? (
          <ChangeEmailRightComp
            onPress={() => {
              setOtpSent(false)
            }}
            text={'Change'}
          />
        ) : null,
        editable: !otpSent,
        // changeStep: and key
        ...textinputStyle,
        testID: 't-mobile',
        accessibilityLabel: 't-mobile',
        onKeyPress: allowBrowserTab,
      },
      {
        fieldName: 'otp',
        ComponentName: TextInputNew,
        displayName: 'Enter',
        hide: !otpSent,
        placeholder: staticStrings.otp,
        validationSchema: OTPValidationSchema,
        ...textinputStyle,
        rightComponent: otpSent ? (
          <ResendComponent onResendOtp={callGenerateOtpApi} resendOtpState={generateOtpstate} />
        ) : null,
        testID: 't-password',
        accessibilityLabel: 't-password',
        onKeyPress: onHandleKeyPress,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

export const loginWtPasswordFormData = (rightComp: any, showPasswd: boolean, onHandleKeyPress: any): any => [
  {
    formItems: [
      {
        fieldName: 'enterLoginCredentials',
        ComponentName: Text,
        title: staticStrings.login,
        type: 'h3',
        textAlign: 'center',
        color: 'BLACK_21',
        fontFamily: 'jiotype-medium',
        fontSize: 24,
      },
      {
        fieldName: 'userName',
        ComponentName: TextInputNew,
        // maxLength: 10,
        validationSchema: email,
        placeholder: staticStrings.userName,
        autoFocus: true,
        // changeStep: and key
        ...textinputStyle,
        testID: 't-mobile',
        accessibilityLabel: 't-mobile',
        onKeyPress: allowBrowserTab,
      },
      {
        fieldName: 'password',
        ComponentName: TextInputNew,
        displayName: 'Enter',
        placeholder: staticStrings.password,
        rightComponent: rightComp,
        validationSchema: passwordValidationSchema,
        secureTextEntry: showPasswd ? false : true,
        ...textinputStyle,
        testID: 't-password',
        accessibilityLabel: 't-password',
        onKeyPress: onHandleKeyPress,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
